
import React from "react"

import { Text } from "@instructure/ui-text"
import { TextInput } from "@instructure/ui-text-input"
import { View } from "@instructure/ui-view"

import { Field, helpers } from "@inst_proserv/finalform-instui"

interface LinkItem {
    title: string
    url: string
}

const isURL = helpers.matches(/^https?:\/\//, "Must be URL");

export const render_link_edit = () => {
    return <>
        <View as="div" margin="0 0 small">
            <Field name="title" component={TextInput}
                renderLabel="Title"
            />
        </View>
        <View as="div" margin="0 0 small">
            <Field name="url" component={TextInput}
                renderLabel="URL"
                validate={isURL}
            />
        </View>
    </>
}

export const render_link_item = (link: LinkItem) => {
    return <>
        <Text color="primary">{link?.title}</Text>
        <View margin="0 small" overflowX="hidden">
            <Text color="secondary" size="x-small">{link?.url?.substring(0, 50)}</Text>
        </View>
    </>
}

interface ContactItem {
    id: string;
    address: string;
    type: string;
    position: string;
    user_id: string;
    workflow_state: string;
}

export const render_email_edit = () => {
    return <>
        <View as="div" margin="0 0 small">
            <Field name="address" component={TextInput}
                renderLabel="Email"
                validate={helpers.looksLikeAnEmail}
            />
        </View>
    </>
}

const isPhoneNumber = helpers.matches(/[0-9]{10}/, "Must be a 10-digit number");

export const render_number_edit = () => {
    return <>
        <View as="div" margin="0 0 small">
            <Field name="address" component={TextInput}
                renderLabel="Number"
                validate={isPhoneNumber}
            />
        </View>
    </>
}

export const render_contact_item = (value: ContactItem) => {
    return <>
        <Text color="primary">{value?.address}</Text>
        {/* {value.position == "1" && <Pill margin="0 small">MAIN</Pill>} */}
    </>
}

